// New Relic deep links (#258). Ported verbatim from load-generator-ui's
// newrelic.ts (#118) — generic NRQL/link builders, nothing load-generator
// specific. Everything here is best-effort: New Relic One's SPA routes are
// not a published contract, so a link may drift — the "copy NRQL" fallback
// (NrLinks.tsx) always works, and each link is only offered when the bit of
// config it needs is present.
//
// Config lives in localStorage (storage.ts), never bundled — a per-browser
// convenience, same as load-generator-ui's.

const NAMESPACE = "multilang-trace-poc";

// Only baseUrl — this screen offers per-order links (Logs, spans NRQL), not
// a dashboard link, so there's no dashboardGuid to collect (unlike
// load-generator-ui's NrConfig, which has one for its run-level dashboard link).
export interface NrConfig {
  baseUrl: string;
}

export const EMPTY_NR_CONFIG: NrConfig = { baseUrl: "" };

function trimBase(url: string): string {
  return url.trim().replace(/\/+$/, "");
}

/** "One order, all spans" — the trace as a table. */
export function orderSpansNrql(orderId: string): string {
  return (
    `SELECT timestamp, service.name, name, otel.status_code, duration * 1000 AS ms, trace.id ` +
    `FROM Span WHERE service.namespace = '${NAMESPACE}' AND orderId = '${orderId}' SINCE 3 days ago`
  );
}

/** Pre-filled NRQL query builder. Best-effort route; needs only baseUrl. */
export function nrqlLink(cfg: NrConfig, nrql: string): string | null {
  const base = trimBase(cfg.baseUrl);
  if (!base) return null;
  return `${base}/nr1-core?query=${encodeURIComponent(nrql)}`;
}

/** New Relic Logs, filtered to the order. Needs only baseUrl. */
export function logsLink(cfg: NrConfig, orderId: string): string | null {
  const base = trimBase(cfg.baseUrl);
  if (!base) return null;
  return `${base}/logs?query=${encodeURIComponent(`orderId:"${orderId}"`)}`;
}

/** Any per-order link needs only the base URL. */
export function hasNrBase(cfg: NrConfig): boolean {
  return trimBase(cfg.baseUrl) !== "";
}
